// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_SCrpV","btn":"btn_u1LQb"};